export default __webpack_public_path__ + "static/media/milestone 300.0959a154.svg";